export enum DictionaryUUIDsEnum {
  ACCEPTED_DOCUMENT = '9b34987a-fef9-47b4-a25b-83ab9402f0ff',
  CHECKLIST = '10b37e38-b975-11eb-8529-0242ac130003',
  EVENT_TYPE = 'f0f9a79a-a5b3-11eb-bcbc-0242ac130002',
  KNM_KIND = 'd2ec803a-a53e-11eb-bcbc-0242ac130002',
  DECISION_KIND = '414abd43-eb02-4373-aba1-71d63aba4f8d',
  KNO_ORGANIZATIONS = 'af002594-a4f0-11eb-bcbc-0242ac130002',
  PROF_KIND = 'e8703904-a545-11eb-bcbc-0242ac130002',
  REQUIREMENT = 'a43f056e-b95c-11eb-8529-0242ac130003',
  RISK_CATEGORY = '18d790d4-a5a9-11eb-bcbc-0242ac130002',
  DANGER_CLASS = 'aae78350-bdfd-12eb-8529-0242ac130003',
  RISK_INDICATORY = '1afc36ea-ba6b-11eb-8529-0242ac130003',
  SUBJECT_TYPE = '641d3956-a5b1-11eb-bcbc-0242ac130002',
  SUBJECT_KIND = '641d3bb8-a5b1-11eb-bcbc-0242ac130002',
  SUBJECT_SUB_KIND = '641d3e60-a5b1-11eb-bcbc-0242ac130002',
  SUPERVISION_TYPE = '1f27d942-a52e-11eb-bcbc-0242ac130002',
  FEDERAL_LAWS = 'ce32a718-0db7-45ce-96dc-33b5918c0d87',
  KNO_LEVELS = 'acd38402-3299-4575-a49c-88e00b2b9eb6',
  KNM_SUBJECT_TYPES = 'eedb105c-4854-4d7f-82f4-e4ba93b350e7',
  POSITIONS = 'b6fc9844-a528-11eb-bcbc-0242ac130002',
  PERMIT_DOCS = 'PERMIT_DOCS_UUID',
  PARTICIPANT_POSITIONS = '003d7ce8-c474-11eb-8529-0242ac130003',
  ERVK = 'c903bb33-d544-4d04-9276-15d0b1c39c8c',
  TARGET_ENTITY = 'TARGET_ENTITY_UUID',
  KNM_TYPES = 'KNM_TYPES_UUID',
  ERVK_CHECK_LIST = 'ERVK_CHECK_LIST',
  CONDITION_TYPES = 'CONDITION_TYPES',
}
